module.exports = __webpack_public_path__ + "static/media/password.5e04c84b.svg";